import { Directive, OnDestroy, OnInit } from '@angular/core';
import { ExgMapLayerManagerService } from '../services';

let layerId = 0;

/*
 * This directive adds a bicycling layer to a google map instance
 * <exg-map-bicycling-layer> <exg-map-bicycling-layer>
 * */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'exg-map-bicycling-layer',
})
export class ExgMapBicyclingLayerDirective implements OnInit, OnDestroy{
  private _addedToManager = false;
  private _id: string = (layerId++).toString();

  constructor( private _manager: ExgMapLayerManagerService ) {}

  ngOnInit(): void {
    if (this._addedToManager) {
      return;
    }
    this._manager.addBicyclingLayer(this);
    this._addedToManager = true;
  }

  /** @internal */
  id(): string { return this._id; }

  /** @internal */
  toString(): string { return `ExgMapBicyclingLayer-${this._id.toString()}`; }

  /** @internal */
  ngOnDestroy(): void {
    this._manager.deleteLayer(this);
  }

}
